export default "__VITE_ASSET__BftynEvo__"